import { useSyncExternalStore } from 'react';

const sub = (fn: () => void): (() => void) => {
  window.addEventListener('online', fn);
  window.addEventListener('offline', fn);
  return () => {
    window.removeEventListener('online', fn);
    window.removeEventListener('offline', fn);
  };
};

/** Device network only; the websocket status says whether the server is reachable. */
export function useOnline(): boolean {
  return useSyncExternalStore(sub, () => navigator.onLine, () => true);
}
